<template lang="pug">
.viewer(:class="{ 'nudge-right': insightsShown, hide: roboWeaveShown }")
  .zoom-level(title="toggle zoom", @click="zoomLevel = zoomLevel === 1 && 0.45 || 1") {{ zoomLevel * 100 + '%' }}
  .copy-high-res-images(@click="copyHighRes", :class="{ shown: highResLoaded }", ref="highRes") copy higher resolution
  .toc(ref="tocPages", @scroll.passive="tocScroll", :class="{ sortable: lens && Object.keys(selectedThemes).length }")
    sorter.hide-age(path="tocSort", v-show="Object.keys(selectedThemes).length")
    //-.sort(v-show="Object.keys(selectedThemes).length")
    //-  label sort by
    //-  button(@click="tocSort = 'AZ'", :class="{ selected: tocSort === 'AZ'  }") Number
    //-  button(@click="tocSort = 'Weight'", :class="{ selected: !tocSort || tocSort === 'Weight'  }") Weight
    //-  button(@click="tocSort = 'vis'", :class="{ selected: tocSort === 'vis'  }") Visuality
    .pages(v-if="pages")
      //-.page(v-for="({ pgn, selected, imgu, url }, i) in pages",
      a.page(v-for="({ pgn, selected, imgu, url }, i) in pages",
            v-lazy:background-image="imgu",
            :key="pgn",
            :href="pgn === 'Analyst' && `?${ folderDoco || doco }#chc` || pgn === 'PDF' && url || null",
            target="_blank",
            :id="`toc-page-${ pgn }`",
            :class="{ selected: pdf === url, enabled: !mutex, 'doco-link': /Analyst|Insights/.test(pgn) }"
            @click="url ? (pgn === 'PDF' ? null : tocClick(url)) : docoLinkClick(pgn === 'Insights')")
        clipboard(:id="`pt|${ doco }|${ pgn }|${ i }`", :text="`img:${ imgu }`", :index="i")
        .number {{ pgn }}
  .all(v-if="false && fullPdf")
    //-pdf.pdf.shown(v-for="(item, page) in new Array(pageCount)",
    //-              :page="page + 1",
    //-              :src="pdf",
    //-              :class="{ small: zoomLevel !== 1, [aspectRatio]: true }"
    //-              :style="{ transform: `scale(${ zoomLevel })` }")
  .single(v-else)
    //pdf.pdf.a(ref="pdf_a", :class="{ shown: true || usePdf === 'a', [currentPage]: true }", :src="pdf", :page="currentPage", :style="{ transform: `scale(${ zoomLevel })` }")
    .card-spacer
    .pdf-cards(:class="{ small: zoomLevel !== 1, [aspectRatio]: true }")
      .pdf-card(:class="{ left: pdfSwapping, up: pdfUp }")
        iframe(:src="(lastPDF || pdf || '').replace(/\\-+.pdf$/, '.pdf') + '#toolbar=0&view=fit'", keep-alive)
      .pdf-card(:class="{ right: pdfSwapping }")
        iframe.tmp(:src="(currentPDF || pdf || '').replace(/\\-+.pdf$/, '.pdf') + '#toolbar=0&view=fit'", keep-alive)
    //pdf.pdf.a(ref="pdf_a", :class="{ shown: usePdf === 'a', [aspectRatio]: true }", :src="pdfA", :style="{ transform: `scale(${ zoomLevel })` }")
    //pdf.pdf.b(ref="pdf_b", :class="{ shown: usePdf === 'b', [aspectRatio]: true }", :src="pdfB", :style="{ transform: `scale(${ zoomLevel })` }")
    //pdf.pdf.c(ref="pdf_c", :class="{ shown: usePdf === 'c', [aspectRatio]: true }", :src="pdfC", :style="{ transform: `scale(${ zoomLevel })` }")
    //pdf.pdf.d(ref="pdf_d", :class="{ shown: usePdf === 'd', [aspectRatio]: true }", :src="pdfD", :style="{ transform: `scale(${ zoomLevel })` }")
    //pdf.pdf.e(ref="pdf_e", :class="{ shown: usePdf === 'e', [aspectRatio]: true }", :src="pdfE", :style="{ transform: `scale(${ zoomLevel })` }")
    //pdf.pdf.f(ref="pdf_f", :class="{ shown: usePdf === 'f', [aspectRatio]: true }", :src="pdfF", :style="{ transform: `scale(${ zoomLevel })` }")
    //pdf.pdf.g(ref="pdf_g", :class="{ shown: usePdf === 'g', [aspectRatio]: true }", :src="pdfG", :style="{ transform: `scale(${ zoomLevel })` }")
    //pdf.pdf.h(ref="pdf_h", :class="{ shown: usePdf === 'h', [aspectRatio]: true }", :src="pdfH", :style="{ transform: `scale(${ zoomLevel })` }")
    //pdf.pdf.i(ref="pdf_i", :class="{ shown: usePdf === 'i', [aspectRatio]: true }", :src="pdfI", :style="{ transform: `scale(${ zoomLevel })` }")
    //pdf.pdf.j(ref="pdf_j", :class="{ shown: usePdf === 'j', [aspectRatio]: true }", :src="pdfJ", :style="{ transform: `scale(${ zoomLevel })` }")
  .title(v-if="info") {{ info.t }}
  .close(v-if="closer", @click="pdf = null") &times;
    global-events(@keyup.esc="pdf = null")
  .next.top(:class="{ enabled: !mutex }", :title="`go to page ${ nextPage }`", @click="gotoPage()") {{ nextPage }}
  .current.top(v-if="currentPage", title="current page") {{ currentPage }}
  .previous.top(:class="{ enabled: !mutex }", :title="`go to page ${ previousPage }`", @click="gotoPage(true)") {{ previousPage }}
  .next.bottom(v-if="!closer", :class="{ enabled: !mutex }", :title="`go to page ${ nextPage }`", @click="gotoPage()") {{ nextPage }}
  .current.bottom(v-if="currentPage && !closer", title="current page") {{ currentPage }}
  .previous.bottom(v-if="!closer", :class="{ enabled: !mutex }", :title="`go to page ${ previousPage }`", @click="gotoPage(true)") {{ previousPage }}
</template>
<script>
import pdf from 'vue-pdf';
import clipboard from '@/components/clipboard';
import sorter from '@/components/sorter';
import { mapGetters } from 'vuex';
import { vuexComputed } from '@/helpers';
import { copyDom } from '@livelybone/copy';
let highResTimer;
export default {
  name: 'viewer',
  props: {
    tocPages: Array,
    closer: Boolean
  },
  watch: {
    pdf(newValue, oldValue) {
      //todo: scroll from up or down if doc is the same instead of shuffle
      console.log('pdf watcher 1', newValue, oldValue);
      this.currentPDF = newValue;
      this.lastPDF = oldValue;
      const differentDoc = didFromPdf(newValue) !== didFromPdf(oldValue);
      console.log('pdf watcher', differentDoc, didFromPdf(newValue), didFromPdf(oldValue));
      const { scrollTocPageIntoView, swap } = this;
      if (differentDoc || /\-1.pdf/.test(oldValue || '')) {
        scrollTocPageIntoView();
        swap();
      }
      function didFromPdf(pdf) {
        return pdf?.replace(/.*\//, '')?.replace(/\-?\d*\.pdf$/, '');
      }
    }
  },
  data() {
    return {
      // topDocVisible: {},
      // filteredDocsVisible: { 0: 1, 1: 1, 2: 1, 3: 1 },
      tocDocsVisible: {},
      invalidator: 1,
      scrolled: 0,
      ready: false,
      pgress: undefined,
      mutex: null,
      timer: null,
      didMount: false,
      pdfSwapping: false,
      pdfUp: false,
      lastPDF: null,
      currentPDF: null
    };
  },
  computed: {
    ...mapGetters(['docoSmallCache', 'doco', 'loadedPages', 'clickedFromPages', 'docoJSON', 'lens', 'filteredDocs', 'selectedThemes', 'docoInsights', 'folderList', 'folderDoco', 'usePdf', 'pdfA', 'pdfB', 'pdfC', 'pdfD', 'pdfE', 'pdfF', 'pdfG', 'pdfH', 'pdfI', 'pdfJ', 'roboWeaveShown', 'clipboardItems', 'loadingImages']),
    ...vuexComputed('zoomLevel', 'pdf', 'insightsShown', 'tocSort', 'engageTocPageCount', 'focusMode'),
    fullPdf() {
      const { pdf } = this;
      console.log('fullPdf', pdf && !/\-\d+.pdf$/.test(pdf));
      return pdf && !/\-\d+.pdf$/.test(pdf);
    },
    aspectRatio() {
      const { pages } = this;
      const firstPage = pages.filter(({ imgw }) => imgw)[0];
      return (firstPage?.imgw > firstPage?.imgh) && 'landscape' || 'portrait';
    },
    currentPage() {
      const { pdf } = this;
      // return documents.filter(({ url }) => url === pdf)[0]?.pgn;
      return (/\-(\d+)\.pdf$/.exec(pdf) || [])[1] * 1;
    },
    currentDid() {
      const { pdf } = this;
      return pdf && (/\/([^\/]+)\-\d+\.pdf$/.exec(pdf) || [])[1];
    },
    info() {
      const { docoSmallCache, currentDid, docoJSON, folderList, doco, lens } = this;
      return (lens && docoJSON) || (lens || folderList) && doco && docoSmallCache[doco] && { pgs: [docoSmallCache[doco]] } || docoSmallCache[currentDid];
      //return !folderList && docoJSON || docoSmallCache[currentDid];
    },
    pgc() {
      return this.tocPages?.length;
    },
    pageCount() {
      console.log('pc', this.info?.pgs, window.g.docoSmallCache, window.g.folderDoco);
      return this.pgc || this.info?.pgs?.[0]?.pgc * 1;
    },
    nextPage() {
      const { currentPage, pageCount } = this;
      const np = currentPage + 1;
      return (np <= pageCount && np) || '';
      //const { currentPage, getPageByPgn } = this;
      //return getPageByPgn(currentPage + 1)?.pgn || '';
    },
    previousPage() {
      const { currentPage, getPageByPgn } = this;
      return currentPage - 1 || '';
      // return getPageByPgn(currentPage - 1)?.pgn || '';
    },
    pages() {
      const {
        doco,
        currentDid,
        currentPage,
        pdf,
        loadedPages,
        clickedFromPages,
        insightPages,
        lens,
        filteredDocs,
        selectedThemes,
        tocSort,
        docoInsights,
        folderList,
        tocPages,
        focusMode,
        $store: { getters }
      } = this;
      //console.log('loadedPages[currentDid]', currentDid, pdf, !doco && loadedPages[currentDid]);
      //console.log('insightPages', insightPages(currentDid));
      //console.log('tocPages', tocPages, '12533');
      let pgs;
      if (doco) {
        //console.log('tocPages', 'doco - 12533');
        pgs = [...(getters['insightsNS/docsWithFilteredKTIs'] || [])];
        const withInsights = pgs.reduce((all, { pgn }) => {
          all[pgn] = true;
          return all;
        }, {});
        if (lens && (filteredDocs || []).length !== pgs) {
          console.log('extra pages:', pgs?.length, filteredDocs?.length);
          const st = Object.keys(selectedThemes);
          const sort = (array) => {
            return tocSort === 'AZ' && array.sort((a, b) => a.pgn - b.pgn)
                || tocSort === 'vis' && array.sort((a, b) => b.vis - a.vis)
                || array.sort((a, b) => a.pgn - b.pgn)//array;
          };
          if (st.length) {
            pgs = sort(pgs.concat((filteredDocs || []).filter(({ pgn }) => !withInsights[pgn])));
          } else {
            pgs = sort(filteredDocs);
          }
        }
        console.log('docoInsights?.kts?.length', docoInsights?.kts?.length);
        pgs = pgs?.filter(({ pgn }) => 'Analyst' !== pgn);
        if (folderList) {
          //pgs?.unshift({ pgn: 'Analyst', imgu: `https://d23xtmsrsmj88h.cloudfront.net/picture-images/${ doco }-1.png` });
        }
        pgs = pgs?.filter(({ pgn }) => 'Insights' !== pgn);
        // if (lens && docoInsights?.kts?.length && !focusMode) {
        if (lens && docoInsights?.kts?.length) {
          pgs?.unshift({ pgn: 'Insights', imgu: `https://d23xtmsrsmj88h.cloudfront.net/picture-images/${ doco }-1.png` });
        }
        pgs = pgs?.filter(({ pgn }) => 'PDF' !== pgn);
        const url = (pdf || '').replace(/\-?\d*\.pdf$/, '.pdf');
        pgs?.push({ pgn: 'PDF', url, imgu: `https://d23xtmsrsmj88h.cloudfront.net/picture-images/${ doco }-1.png` });
      }
      return (
        // (tocPages && mapTocPages(tocPages)) ||
        tocPages ||
        (doco && pgs) ||
        makePages((clickedFromPages && loadedPages[currentDid]) || Object.keys(insightPages(currentDid) || {}))
      );
      function mapTocPages(pages) {
        //{ pgn, selected, imgu, url }
        /*
        docId: "6S4CeDND-kq97CaUrFrYFQ"
        folder: "STNC-Fact-Sheets"
        page: 2
        publishedDate: "2021-04-21T13:18:50"
        publisherId: "stancecap"
        title: "Fact Sheet"
         */
        return pages.map(({ docId: did, page: pgn }) => ({
          pgn,
          url: `https://content.weave.ai/documents/${ did || 'no did' }-${ pgn }.pdf`,
          imgu: `https://content.weave.ai/picture-images/${ did || 'no did' }-${ pgn }.png`,
          selected: currentPage === pgn
        }));
      }
      //return doco && getters['insightsNS/docsWithFilteredKTIs'];
      function makePages(pgns) {
        return (pgns || []).map(pgn => {
          const base = (pdf || '').replace(/\d+\.pdf$/, '') + pgn;
          return {
            pgn,
            url: base + '.pdf',
            imgu: base.replace(/\/documents\//, '/picture-images/') + '.png',
            selected: currentPage === pgn
          };
        });
      }
    },
    highResLoaded() {
      const { clipboardItems, loadingImages } = this;
      const values = Object.values(loadingImages);
      return clipboardItems.length && values.length && !values.includes('pending');
    }
  },
  methods: {
    scrollTocPageIntoView() {
      const { $refs: { tocPages: toc }, pdf } = this;
      const canScroll = toc.scrollHeight > toc.clientHeight;
      const pgn = pdf?.replace(/\.pdf$/, '')?.replace(/.+?(\d*)$/, '$1');
      const page = toc.querySelector(`#toc-page-${ pgn || 1 }`);
      console.log('scrollTocPageIntoView', pdf, canScroll, pgn, page);
      if (canScroll && page) {
        setTimeout(() => {
          try {
            console.log('scrollTop scroller', pgn);
            const top = page.getBoundingClientRect().top;
            //toc.scrollTop = 20;
            toc.scrollTop = page.offsetTop;
            // page.scrollIntoView({ behavior: 'smooth' });
          } catch (ex) {}
        }, 200);
      }
    },
    swap() {
      console.log('swap');
      this.pdfUp = true;
      this.pdfSwapping = true;
      setTimeout(() => {
        this.pdfUp = false;
        this.pdfSwapping = false;
        setTimeout(() => {
          this.lastPDF = this.currentPDF;
        }, 700);
      }, 300);
    },
    copyHighRes() {
      copyDom(document.querySelector('.high-res-clipboard-images > div'), { clearSelect: true });
      const { $refs: { highRes: button } } = this;
      button.classList.add('big');
      clearTimeout(highResTimer);
      highResTimer = setTimeout(() => button.classList.remove('big'), 250);
    },
    tocScroll() {
      //console.log('tocScroll');
      this.tocDocsVisible = arrayFromScrollTop(this.$refs.tocPages.scrollTop);
      function arrayFromScrollTop(scrollTop) {
        const offset = Math.floor(scrollTop / 228);
        return Array.from(new Array(20), (item, i) => i + offset).reduce((map, item) => ({ ...map, [item]: 1 }), {});
      }
    },
    tocClick(url) {
      const { mutex } = this;
      const delay = (isWinChrome() && 1000) || 0;
      const click = () => {
        this.mutex = null;
        this.pdf = url;
        this.pdfView = true;
      };
      clearTimeout(this.timer);
      if (mutex) {
        this.timer = setTimeout(click, delay);
      } else {
        click();
        this.mutex = 1;
        this.timer = setTimeout(() => (this.mutex = null), delay);
      }
    },
    docoLinkClick(insights) {
      if (insights) {
        this.showInsights();
      } else {
        //location.href = location.href.replace(/\?.*$/, `?${ this.doco }`);
      }
    },
    showInsights() {
      this.insightsShown = true;
    },
    getPageByPgn(number) {
      return { url: (this.pdf || '').replace(/\-\d+(\.pdf)$/, '-' + number + '$1') };
      // todo: write this
      //return this.documents.filter(({ pgn }) => pgn === number)[0];
    },
    gotoPage(previous) {
      const number = this[(previous && 'previousPage') || 'nextPage'];
      if (number) {
        const { url } = this.getPageByPgn(number) || {};
        if (url) {
          clearTimeout(this.timer);
          const delay = (isWinChrome() && 1000) || 0;
          const click = () => {
            this.pdf = url;
            this.mutex = null;
          };
          if (this.mutex) {
            this.timer = setTimeout(click, delay);
          } else {
            click();
            this.mutex = 1;
            this.timer = setTimeout(() => (this.mutex = null), delay);
          }
          this.pdf = url;
        }
      }
    },
    readInsightKey(key) {
      let did;
      let pgn;
      let w;
      let k;
      (key || '').replace(/^([^\|]+?)\-(\d+)\|([\d\.]+)\|(.+)/, (match, p1, p2, p3, p4) => {
        did = p1;
        pgn = p2;
        w = p3;
        try {
          k = atob(p4);
        } catch (ex) {}
      });
      // return JSON.stringify({ did, pgn, w, k });
      return { did, pgn, w, k, imgu: `https://d23xtmsrsmj88h.cloudfront.net/picture-images/${ did }-${ pgn }.png` };
    },
    insightPages(did) {
      const {
        readInsightKey,
        $store: { getters }
      } = this;
      const { documents } = getters['insightsNS/cheatsheet'];
      const { insights } = (documents || {})[did] || {};
      const items = insights?.map(readInsightKey);
      return items?.reduce((all, insight) => {
        //console.log('insight', insight);
        const { pgn, imgu } = insight;
        const p = (all[pgn] = all[pgn] || { pgn, imgu });
        const pi = (p.insights = p.insights || []);
        p.kti = pi;
        pi.push(insight);
        return all;
      }, {});
    }
  },
  components: { pdf, clipboard, sorter },
  mounted() {
    console.log('viewer mounted', this.pdf);
    const { tocScroll, scrollTocPageIntoView } = this;
    tocScroll();
    setTimeout(() => this.didMount = true, 2000);
    scrollTocPageIntoView();
  },
  destroyed() {
    console.log('destroyed');
    this.engageTocPageCount = null;
  }
};
function isWinChrome() {
  return isWindows() && !!window.chrome;
}
function isWindows() {
  return /windows/i.test(navigator.userAgent);
}
</script>
<style scoped lang="scss">
@import '../../scss/global';
.viewer {
  box-sizing: border-box;
  padding-top: 4rem;
  height: 180vh;
  display: grid;
  grid-template-columns: 12.5rem 1fr;
  //background-color: #888;
  background-color: #525659;
  position: relative;
  transition: all 250ms ease-in-out;
  &.hide {
    height: 1px;
    width: 1px;
    overflow: hidden;
    pointer-events: none;
    opacity: 0;
  }
  &.nudge-right {
    left: 21vw;
    width: 79vw;
  }
  .zoom-level {
    cursor: pointer;
    position: absolute;
    top: 2rem;
    left: 12.5rem;
    padding: 0.125rem 0.25rem;
    border: 1px solid white;
    border-radius: 3px;
    color: white;
    font-weight: bold;
  }
  & > .title {
    position: absolute;
    top: 2.25rem;
    left: 16.5rem;
    right: 2.75rem;
    color: white;
    text-align: center;
    font-size: 1.3rem;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .copy-high-res-images {
    cursor: pointer;
    position: absolute;
    top: 1.5rem;
    left: 0.9rem;
    width: auto;
    box-sizing: border-box;
    padding: 0.5rem 0.5rem;
    background-color: orange;
    border-radius: 0.125rem;
    text-transform: uppercase;
    font-size: 0.75rem;
    color: white;
    font-weight: 600;
    transition: transform 250ms ease-in-out;
    transform: translate3d(-100vw, 0, 0);
    &.shown {
      transform: translate3d(0, 0, 0);
      &.big {
        transform: translate3d(0, 0, 0) scale(1.05);
      }
    }
  }
  .toc {
    //height: 100vh;
    height: 100%;
    overflow: auto;
    position: relative;
    &.sortable {
      padding-top: 3.5rem;
    }
    .sorter {
      position: absolute;
      top: 0.5rem;
      left: 0.5rem;
      color: white;
      border-color: white;
    }
    .sort {
      position: absolute;
      top: 0.5rem;
      left: 0.5rem;
      display: grid;
      justify-content: space-evenly;
      grid-template-columns: repeat(3, 1fr);
      color: white;
      padding-top: 1rem;
      padding-left: 0.125rem;
      padding-right: 0.25rem;
      label {
        position: absolute;
        top: 0;
        left: 0.5rem;
        font-size: 0.8rem;
      }
      button {
        background-color: transparent;
        color: white;
        border: 1px solid transparent;
        border-radius: 0.125rem;
        box-sizing: border-box;
        padding: 0.25rem 0.5rem;
        font-weight: bold;
        text-decoration: underline;
        &:focus {
          outline: none;
        }
        &:not(.selected) {
          text-decoration: none;
          font-weight: normal;
          cursor: pointer;
          &:hover {
            border-color: white;
          }
        }
      }
    }
    .pages {
      box-sizing: border-box;
      padding: 0.4rem 1rem 0.25rem;
      .page {
        text-decoration: none;
        display: block;
        cursor: pointer;
        height: 14rem;
        background: white no-repeat center;
        background-size: contain;
        margin-bottom: 0.25rem;
        box-shadow: 1px 1px 6px #777;
        opacity: 0.7;
        position: relative;
        &.enabled {
          opacity: 1;
        }
        &.selected {
          outline: 0.4rem solid orange;
          .number {
            background-color: transparent;
          }
        }
        &.doco-link {
          height: 3rem;
          background-position: left;
          border: 0.25rem solid white;
          margin-bottom: 0.5rem;
          box-sizing: border-box;
          & + .doco-link {
            //display: none;
          }
          .number {
            padding-top: 0.25rem;
            padding-left: 3rem;
            color: orange;
            font-size: 1.5rem;
            text-shadow: none;
            /*text-shadow: 1px 1px 0 white,
                         -1px -1px 0 white,
                         0 1px 0 white,
                         1px 0 0 white,
                         0 -1px 0 white,
                         -1px 0 0 white,
                         1px 1px 1px white,
                         -1px -1px 1px white,
                         0 1px 1px white,
                         1px 0 1px white,
                         0 -1px 1px white,
                         -1px 0 1px white,
                         2px 2px 0 #888,
                         -2px -2px 0 #888,
                         0 2px 0 #888,
                         2px 0 0 #888,
                         0 -2px 0 #888,
                         -2px 0 0 #888,
                         2px 2px 2px #888,
                         -2px -2px 1px #888,
                         0 2px 1px #888,
                         2px 0 1px #888,
                         0 -2px 1px #888,
                         -2px 0 1px #888;*/
          }
        }
        .number {
          box-sizing: border-box;
          height: 100%;
          font-size: 4rem;
          font-weight: bold;
          text-align: center;
          padding-top: 5rem;
          color: white;
          background-color: rgba(255, 255, 255, 0.4);
          text-shadow: 1px 1px 0 #bababa,
                       -1px -1px 0 #bababa,
                       0 1px 0 #bababa,
                       1px 0 0 #bababa,
                       0 -1px 0 #bababa,
                       -1px 0 0 #bababa,
                       1px 1px 1px #bababa,
                       -1px -1px 1px #bababa,
                       0 1px 1px #bababa,
                       1px 0 1px #bababa,
                       0 -1px 1px #bababa,
                       -1px 0 1px #bababa;
        }
      }
    }
  }
  .all {
    height: 123rem;
    overflow: auto;
    .pdf {
      margin-bottom: 1rem;
      &.small {
        margin-bottom: -70%;
        &.landscape {
          margin-bottom: -28%;
        }
      }
    }
  }
  .pdf {
    transform-origin: top center;
    box-shadow: 7px 7px 7px #777;
    width: 100%;
  }
  .single {
    position: relative;
    transform: translate3d(0, 0, -1px);
    & > .card-spacer {
      height: 180vh;
    }
    & > .pdf-cards {
      position: absolute;
      top: 0;
      left: 0;
      height: 180vh;
      right: 0;
      transform-origin: top center;
      transform: translate3d(0, 0, -1px);
      &.small {
        transform: scale(0.45) translate3d(0, 0, -1px);
      }
      .pdf-card {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        //background: no-repeat center url('https://sailboatdata.com/storage/images/sailboat/photo/windrider_rave_photo.jpg');
        transform-origin: left 140%;
        transition: all 300ms ease-in;
        transform: translate3d(0, 0, -1px);
        background-size: cover;
        &.up {
          z-index: 1;
        }
        &.left {
          pointer-events: none;
          transform: translate3d(-12%, 0, 0) rotate(-10deg);
          transition: all 300ms ease-out;
        }
        &.right {
          transform: translate3d(72%, 0, 0) rotate(20deg);
          transition: all 300ms ease-out;
        }
        & > iframe {
          //opacity: 0.25;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          //width: 47rem;
          //height: 66rem;
          border: none;
          background-color: transparent;
        }
      }
      .pdf-card + .pdf-card {
        transform-origin: right 170%;
        //background-image: url('https://coastalkayak.com/app/uploads/2018/07/Drone_sailing-web.jpg')
      }
    }
    & > .NOTpdf-card {

      & > iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 47rem;
        height: 66rem;
        border: none;
        background-color: transparent;
      }
    }
    .pdf {
      opacity: 0;
      transition: opacity 250ms ease-in-out 250ms;
      will-change: opacity;
      position: absolute !important;
      pointer-events: none;
      &.shown {
        opacity: 1;
        position: relative !important;
        pointer-events: all;
      }
    }
  }
  .close {
    cursor: pointer;
    position: absolute;
    top: 1.75rem;
    right: 1rem;
    z-index: 5;
    color: white;
    font-size: 1.5rem;
  }
  .next,
  .previous,
  .current {
    position: absolute;
    z-index: 52;
    transform: translate3d(0, 0, 1px);
    color: white;
    font-size: 2.5rem;
    font-weight: bold;
    cursor: default;
    padding: 0.25rem 0.75rem;
    border: 1px solid transparent;
    border-radius: 0.25rem;
    user-select: none;
    text-shadow: 1px 1px 0 #bababa,
                 -1px -1px 0 #bababa,
                 0 1px 0 #bababa,
                 1px 0 0 #bababa,
                 0 -1px 0 #bababa,
                 -1px 0 0 #bababa,
                 1px 1px 1px #bababa,
                 -1px -1px 1px #bababa,
                 0 1px 1px #bababa,
                 1px 0 1px #bababa,
                 0 -1px 1px #bababa,
                 -1px 0 1px #bababa;
    opacity: 0.7;
    &.enabled {
      opacity: 1;
    }
    &:hover:not(.current) {
      cursor: pointer;
      border-color: $brn;
      background-color: white;
      text-shadow: none;
      color: $brn;
      box-shadow: 0 0 3px $brn;
      not-text-shadow: 1px 1px 0 black,
                       -1px -1px 0 black,
                       0 1px 0 black,
                       1px 0 0 black,
                       0 -1px 0 black,
                       -1px 0 0 black,
        1px 1px 1px black,
                       -1px -1px 1px black,
                       0 1px 1px black,
                       1px 0 1px black,
                       0 -1px 1px black,
                       -1px 0 1px black;
    }
    &.top {
      top: 4.75rem;
    }
    &.bottom {
      bottom: 2.75rem;
    }
    &.next {
      //right: 3.5rem;
      right: 1.125rem;
    }
    &.previous {
      left: 13.5rem;
    }
    &.current {
      color: $brn;
      text-shadow: none;
      border-color: $brn;
      border-radius: 0.25rem;
      background-color: white;
      box-shadow: 0 0 3px $brn;
      opacity: 1 !important;
      margin-left: 5%;
      left: 50%;
      transform: translate3d(-50%, 0, 0);
    }
  }
}
</style>
<style lang="scss">
.viewer {
  .toc {
    .pages {
      .page {
        &.doco-link {
          .copy {
            display: none;
          }
        }
        .copy {
          position: absolute;
          bottom: 0.5rem;
          right: 0.5rem;
          .paper {
            opacity: 0;
          }
        }
        &:hover .copy .paper {
          opacity: 0.35;
        }
      }
    }
  }
}
</style>
